module.exports = __webpack_public_path__ + "img/Updated_Logo.e205bdfe.png";